<template>
    <div class="shop">
        <div class="info">
            <div class="header">
                <img src="@/assets/img/next-white.png" class="back" @click="back">
            </div>
            <div class="photo">
                <carousel :autoplay="true"
                          :autoplayTimeout="3000"
                          :perPage="1"
                          :centerMode="true"
                          :loop="true"
                          v-model="photoIndex"
                          :paginationPosition="'bottom-overlay'"
                          paginationActiveColor="#339933"
                          paginationColor="#DDDDDD">
                    <slide class="slide"
                           v-for="photo in shop.photos"
                           @click.stop.prevent
                           :style="{ 'background-image': 'url(' + photo.url + ')' }"
                           :key="photo.id">
                        <img v-gallery="'shop-' + id" :src="photo.url" :alt="shop.alias">
                    </slide>
                </carousel>
            </div>
            <div class="content">
                <div class="note" v-if="shop.caution">{{ shop.caution }}</div>
            </div>
            <div class="divider full" />
        </div>
        <div class="custom">
            <div class="advanced" @click="showAdvanced">
                <div class="title">
                    進階需求?
                </div>
                <div class="buttons">
                    <div class="button" :class="{'active': isSelfBuy}">
                        <img v-show="!isSelfBuy" src="@/assets/img/ordered.svg">
                        <img v-show="isSelfBuy" src="@/assets/img/ordered-green.svg">
                        已訂購
                    </div>
                    <div class="button" :class="{'active': isInsulation}">
                        <img v-show="!isInsulation" src="@/assets/img/insulation.svg">
                        <img v-show="isInsulation" src="@/assets/img/insulation-green.svg">
                        需保溫
                    </div>
                    <div class="button" :class="{'active': vat.length}">
                        <img v-show="!vat.length" src="@/assets/img/vat.svg">
                        <img v-show="vat.length" src="@/assets/img/vat-green.svg">
                        統編
                    </div>
                </div>
            </div>
            <div v-if="categories.length" class="note" @click="showNote">
                <img src="@/assets/img/pen.svg">
                <div>
                    {{ note || '直接輸入想要的商品' }}
                </div>
            </div>
            <div class="note-show" v-else @click="showNote">
                <shop-note v-model="note"/>
            </div>
        </div>
        <div class="menu">
            <div ref="outside" class="category-scroll" v-show="categories.length > 1">
                <div class="outside" :class="{active: outsideEnable}" v-show="categories.length">
                    <div class="scroll-div">
                        <div class="scroll" ref="scroll">
                            <div class="scroll-content" v-show="!isShowCategories">
                                <div class="scroll-item"
                                     v-for="category in categories"
                                     :key="category.id"
                                     @click="selectCategory(category)"
                                     :ref="'item-' + category.id"
                                     :class="{active: category.id === selectedCategory.id}">
                                    <div>
                                        {{ category.name }}
                                    </div>
                                </div>
                            </div>
                            <div class="scroll-title" v-show="isShowCategories">
                                所有類別
                            </div>
                        </div>
                        <div class="scroll-btn" @click="isShowCategories = !isShowCategories">
                            <img :class="{up: isShowCategories}" src="@/assets/img/down-green.svg">
                        </div>
                    </div>
                    <div class="scroll-all" v-show="isShowCategories">
                        <div class="scroll-item"
                             v-for="category in categories"
                             :key="category.id"
                             @click="selectCategory(category, true)"
                             :class="{active: category.id === selectedCategory.id}">
                            <div>
                                {{ category.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="category" v-for="category in categories" :key="'menu-' + category.id" :ref="'menu-' + category.id">
                    <span>{{ category.name }}</span>
                    <div class="product" v-for="product in category.products" :key="'product-' + product.id" @click="showProduct(product)">
                        <div class="content">
                            <div class="title">{{ product.name }}</div>
                            <div class="description">{{ product.description }}</div>
                            <div class="price">＄ {{ product.is_elastic ? '依店內價格' : product.price }}</div>
                        </div>
                        <div class="photo" v-if="product.photo" :style="{ 'background-image': 'url(' + product.photo.url + ')' }"/>
                        <div v-if="product.is_shortage" class="shortage" @click.stop>
                            <img src="@/assets/img/shortage.svg">
                        </div>
                    </div>
                </div>
            </div>
            <div class="float-buttons">
                <div class="float">
                    <div class="button" @click="goToCart" v-show="hasProduct">
                        <div>
                            <div class="price">
                                $ {{ cartProductPrice }}
                            </div>
                        </div>
                        <div class="content">
                            {{ '要送去哪裡？' }}
                        </div>
                        <div>
                            <div class="count">
                                {{ cartCount }} 項
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <shop-product is-liquor="true" ref="showProduct"/>
        <shop-advanced-modal ref="showAdvanced" @onConfirm="setAdvanced"/>
        <shop-note-modal ref="showNote" @onConfirm="setNote"/>
        <div class="shadow" v-if="isEdit"></div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Product from './shop/Product';
    import ScrollBooster from 'scrollbooster';
    import * as R from 'ramda';
    import ShopAdvancedModal from "./components/modal/ShopAdvancedModal";
    import ShopNoteModal from "./components/modal/ShopNoteModal";
    import Note from "./shop/Note";

    export default {
        name: 'LiquorShop',
        metaInfo() {
            let metaTitle = '跑跑腿';
            if (this.shop.alias) {
                metaTitle =  this.shop.alias + ' - ' + metaTitle;
            }
            let metaContent = '最靈活的生活服務平台，提供隨心所欲的跑腿服務！代買代購代排隊，不用出門就能幫您外送到家，不限店家、距離或金額。一單多點服務，省下寶貴時間，生活享受不只一點，呼叫騎士為您即刻出發！';
            if (this.shop.description) {
                metaContent = this.shop.description + "\n" + metaContent;
            }
            let metaArr = [
                {vmid: 'description', name: 'description', content: metaContent},
                {vmid: 'og:title', property: 'og:title', content: metaTitle},
                {vmid: 'og:description', property: 'og:description', content: metaContent},
                {vmid: 'robots', name: 'robots', content: 'all'}
            ];

            return {
                title: metaTitle,
                meta: metaArr,
            }
        },
        data() {
            return {
                id: 0,
                photoIndex: 0,
                previousRoute: {
                    name: null
                },
                photoUrl: '',
                isShowCategories: false,
                selectedCategory: {
                    id: 0,
                },
                sb: null,
                outsideEnable: false,
                isSelfBuy: false,
                selfBuyName: '',
                selfBuyPhone: '',
                isInsulation: false,
                isEdit: false,
                note: '',
                vat: '',
                oldNote: '',
                oldVat: '',
            };
        },
        components: {
            'shop-product': Product,
            'shop-advanced-modal': ShopAdvancedModal,
            'shop-note-modal': ShopNoteModal,
            'shop-note': Note,
        },
        computed: {
            shop() {
                return this.shopById(this.id) || {};
            },
            hasProduct() {
               return this.cart.locations.length
            },
            categories() {
                if (!this.shop || !this.shop.categories) {
                    return [];
                }

                return this.shop.categories.filter(category => category.products.length);
            },
            ...mapGetters(['shopById', 'findShopLocationIndex', 'cartLocationById', 'cart', 'cartCount', 'cartProductPrice', 'menus'])
        },
        methods: {
            initShop() {
                this.id = this.$route.params.id;
                if (!this.id) {
                    let index = this.menus.findIndex(menu => menu.type === 'liquor')
                    if (index) this.id = this.menus[index].target;
                }

                let payload = {id: this.id};

                this.getShop(payload).then(() => {
                    if (this.selectedCategory) {
                        let index = this.shop.categories.findIndex(c => c.id == this.selectedCategory.id);
                        if (index < 0) {
                            this.selectedCategory = null;
                        }
                    }

                    if (! this.selectedCategory && this.shop.categories.length) {
                        this.selectedCategory = this.shop.categories[0];
                    }

                    if (this.sb) {
                        this.$nextTick(() => {
                            this.sb.updateMetrics();
                        });
                    }

                    this.initCart('liquor');

                    let index = this.findShopLocationIndex(this.id);
                    if (index >= 0) {
                        let location = R.clone(this.cartLocationById(index));
                        this.note = location.note || '';
                        this.vat = location.vat || '';
                        this.isInsulation = location.isInsulation || false;
                        this.isSelfBuy = location.isSelfBuy || false;
                        this.selfBuyName = location.selfBuyName || '';
                        this.selfBuyPhone = location.selfBuyPhone || '';
                    }
                });
            },
            initScroll() {
                let viewport = document.querySelector('.scroll');
                let content = viewport.querySelector('.scroll-content');
                this.sb = new ScrollBooster({
                    viewport,
                    content,
                    mode: 'x',
                    onUpdate: (data)=> {
                        content.style.transform = `translateX(${-data.position.x}px)`
                    }
                });
            },
            back() {
                if (! this.previousRoute.name) {
                    return this.$router.replace({
                        name: 'home'
                    });
                }

                this.$router.back();
            },
            selectCategory(category, move) {
                this.selectedCategory  = category;
                this.isShowCategories = false;
                window.scrollTo({
                    top: this.$refs[`menu-${category.id}`][0].offsetTop - 110,
                    behavior: "smooth"
                });

                this.$nextTick(() => {
                    let categoryOffsetLeft = this.$refs[`item-${category.id}`][0].offsetLeft;
                    let scrollWidth = this.$refs.scroll.getBoundingClientRect().width;
                    let scrollLeft = this.$refs.scroll.scrollLeft;

                    if (move && categoryOffsetLeft > (scrollWidth + scrollLeft)) {
                        this.sb.setPosition({
                            x: categoryOffsetLeft,
                            y: 0
                        });
                    }
                })
            },
            showProduct(product) {
                window.location.hash = product.id;
                let url = this.shop.photos.length > this.photoUrl ? this.shop.photos[this.photoIndex].url : '';
                this.$refs.showProduct.show(this.shop, product, url);
            },
            updateLocation() {
                let index = this.findShopLocationIndex(this.shop.id);
                if (index >= 0) {
                    let location = R.clone(this.cartLocationById(index));
                    location.vat = this.vat;
                    location.note = this.note;
                    location.isInsulation = this.isInsulation;
                    location.isSelfBuy = this.isSelfBuy;
                    location.selfBuyName = this.selfBuyName;
                    location.selfBuyPhone = this.selfBuyPhone;
                    this.putCartLocation({
                        key: index,
                        location: location,
                    })
                } else {
                    this.addCartLocation({
                        shop_id: this.shop.id,
                        alias: this.shop.alias,
                        city: this.shop.city,
                        district: this.shop.district,
                        road: this.shop.road,
                        additional: this.shop.additional,
                        latitude: this.shop.latitude,
                        longitude: this.shop.longitude,
                        vat: this.vat,
                        note: this.note,
                        isInsulation: this.isInsulation,
                        isSelfBuy: this.isSelfBuy,
                        selfBuyName: this.selfBuyName,
                        selfBuyPhone: this.selfBuyPhone,
                        products: [],
                    });
                }
            },
            goToCart() {
                this.$router.push({name: 'liquor'});
            },
            showAdvanced() {
                this.$refs.showAdvanced.show(this.isSelfBuy, this.isInsulation, this.vat, this.selfBuyName, this.selfBuyPhone);
            },
            setAdvanced(advance) {
                this.isSelfBuy = advance['ordered'];
                this.selfBuyName = advance['orderedName'];
                this.selfBuyPhone = advance['orderedPhone'];
                this.isInsulation = advance['insulation'];
                this.vat = advance['vat'];
                this.updateLocation();
            },
            showNote() {
                this.$refs.showNote.show(this.note);
            },
            setNote(note) {
                this.note = note;
                this.updateLocation();
            },
            ...mapActions(['initCart', 'clearCart', 'getShop', 'deleteFavorite', 'addFavorite', 'addCartLocation', 'putCartLocation', 'putCartLastLocation'])
        },
        created() {
            this.initShop();
        },
        mounted() {
            this.initScroll();
        },
        updated() {
            if (this.sb) {
                this.$nextTick(() => {
                    this.sb.updateMetrics();
                })
            }
        },
        destroyed() {
            this.sb.destroy();
        },
        beforeRouteEnter(to, from, next) {
            next(vm => vm.previousRoute = from);
        },
        watch: {
            '$route'() {
                let hash = this.$route.hash.replace('#', '');

                if (isNaN(parseInt(hash)) && this.$refs.showProduct.isShow) {
                    this.$refs.showProduct.close();
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    textarea {
        min-height: 3em !important;
    }

    .shop {
        position: relative;
        width: inherit;

        .shadow {
            background-color: rgba(0,0,0,0.5);
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            width: inherit;
            z-index: 100;
        }

        .slide {
            overflow: hidden;
            height: 250px;
            background-position: 50% 50%;
            background-size: cover;

            & img {
                opacity: 0;
                width: 100%;
                height: 100%;
            }
        }

        .outside {
            background: white;

            &.active {
                position: fixed;
                width: inherit;
                max-width: 500px;
                top: 50px;
                z-index: 99;
            }
        }

        .float-buttons {
            min-height: 66px;
            width: inherit;

            .float {
                position: fixed;
                bottom: 0;
                width: inherit;
                max-width: 500px;
                background-color: white;

                .button {
                    cursor: pointer;
                    border-radius: 35px;
                    background-color: #339933;
                    color: #FFFFFF;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                    text-align: center;
                    padding: 13px 30px;
                    margin: 10px 15px;
                    display: flex;
                    justify-content: space-between;

                    &.preview {
                        background-color: #9b9b9b;
                    }
                }
            }
        }
    }

    .info {
        position: relative;
        width: inherit;

        .photo {
            min-height: 50px;
        }

        .divider {
            background-color: #F5F5F5;
            height: 1px;
            margin: 15px;

            &.full {
                margin: 15px 0;
            }
        }

        .header {
            z-index: 9;
            position: absolute;
            width: inherit;
            max-width: 500px;
            height: 50px;
            background: linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%);
            box-sizing: border-box;
            padding: 15px;
            display: flex;
            justify-content: space-between;
            top: 0;

            &.show {
                background: white;
            }

            .left {
                color: #339933;
                font-size: 14px;
                line-height: 22px;
            }

            .left-icon {
                width: 25px;
                height: 25px;

                &:not(:last-child) {
                    margin-right: 10px;
                }
            }


            .back {
                transform: rotateY(180deg);
                width: 20px;
                height: 20px;
            }
        }

        .content {
            padding: 15px;
            text-align: left;
            color: #000000;
            font-weight: 500;
            letter-spacing: 0;

            .title {
                height: 25px;

                span {
                    font-size: 18px;
                    line-height: 25px;
                }
            }

            .description {
                margin: 15px 0;
                color: #4A4A4A;
                font-size: 14px;
                line-height: 23.8px;
                max-height: 5em;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }

            .note {
                color: #4A4A4A;
                font-size: 14px;
                line-height: 23.8px;
                white-space: pre-wrap;

                span {
                    color: #9B9B9B;
                    font-size: 13px;
                    line-height: 18px;
                    margin-bottom: 5px;
                }
            }

            .buttons {
                margin-top: 15px;

                img {
                    width: 18px;
                    height: 18px;
                }

                .more {
                    color: #339933;
                    font-size: 14px;
                    line-height: 20px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                }

                .tip {
                    margin-top: 5px;
                    color: #9B9B9B;
                    font-size: 14px;
                    line-height: 20px;
                    display: flex;
                    justify-content: space-between;

                    .change {
                        border-radius: 15px;
                        background-color: #4A4A4A;
                        color: #FFFFFF;
                        font-size: 14px;
                        line-height: 20px;
                        padding: 5px 15px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        text-decoration: none;
                    }
                }
            }
        }
    }

    .menu {
        width: inherit;

        .category-scroll {
            width: inherit;
            min-height: 60px;
        }

        .scroll-div {
            display: flex;
            align-items: center;
            position: relative;
        }

        .scroll-all {
            display: flex;
            flex-wrap: wrap;
            border-top: solid 1px #F5F5F5;
            padding: 10px 0;
        }

        .scroll {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            -ms-overflow-style: -ms-autohiding-scrollbar;
            min-height: 57px;
            width: calc(100% - 30px);
            display: flex;
            align-items: center;
        }

        .scroll-title {
            text-align: left;
            color: #4A4A4A;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            margin-left: 15px;
        }

        .scroll-content {
            display: flex;
            flex-wrap: nowrap;
            width: fit-content;
        }

        .scroll::-webkit-scrollbar {
            display: none;
        }

        .scroll-item {
            padding: 10px;
            background-color: #FFFFFF;
            border-radius: 5px;
            box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
            margin: 7px;
            white-space: nowrap;
            cursor: pointer;

            &:first-child {
                margin-left: 15px;
            }

            &:last-child {
                margin-right: 15px;
            }

            &.active {
                border-bottom: 3px solid #339933;
            }
        }

        .scroll-btn {
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), #fff 30%, #fff);

            img {
                width: 20px;
                height: 20px;

                &.up {
                    transform: rotate(180deg);
                }
            }
        }

        .category {
            text-align: left;
            padding: 15px;

            &:not(:last-child) {
                border-bottom: solid 5px #EEEEEE;
            }

            span {
                color: #000000;
                font-size: 18px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 25px;
            }

            .product {
                display: flex;
                justify-content: space-between;
                padding: 10px 0;
                cursor: pointer;
                position: relative;

                &:not(:last-child) {
                    border-bottom: solid 1px #DDDDDD;
                }

                .content {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }

                .title {
                    color: #4A4A4A;
                    font-size: 16px;
                    letter-spacing: 0;
                    line-height: 22px;
                }

                .description {
                    color: #9B9B9B;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                    max-height: 3em;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }

                .price {
                    color: #4A4A4A;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                }

                .photo {
                    width: 84px;
                    height: 84px;
                    min-width: 84px;
                    background-position: 50% 50%;
                    background-size: cover;
                    border-radius: 5px;
                    box-sizing: border-box;
                }

                .shortage {
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    position: absolute;
                    background-color: rgba(255, 255, 255, .75);
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-start;
                    user-select: none;

                    img {
                        margin-top: 5px;
                    }
                }
            }
        }
    }

    .custom {
        padding-bottom: 15px;
        border-bottom: 5px solid #eee;

        .advanced {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 15px;
            padding: 10px 15px;
            border-radius: 5px;
            background-color: #FFFFFF;
            box-shadow: 0 2px 8px 0 rgba(51,153,51,0.35);
            cursor: pointer;
            user-select: none;

            .title {
                color: #339933;
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 20px;
            }

            .buttons {
                display: flex;
                align-items: center;

                .button {
                    display: flex;
                    align-items: center;
                    color: #9b9b9b;

                    img {
                        margin-left: 10px;
                        margin-right: 2px;
                    }

                    &.active {
                        color: #339933;
                    }
                }
            }
        }

        .note {
            background-color: #339933;
            color: white;
            font-size: 14px;
            font-weight: 500;
            margin: 10px 15px 0 15px;
            padding: 10px 15px;
            border-radius: 5px;
            box-shadow: 0 0 3px 0 rgba(51,153,51,0.5);
            display: flex;
            justify-content: left;
            align-items: center;
            user-select: none;
            cursor: pointer;

            img {
                margin-right: 5px;
            }

            div {
                word-break: keep-all;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: block;
            }
        }

        .note-show {
            margin: 10px 15px 0 15px;
            border-radius: 5px;
            background-color: #FFFFFF;
            box-shadow: 0 0 3px 0 rgba(51,153,51,0.5);
            padding: 10px;

            .shop-note {
                .title {
                    color: #339933;
                }
            }
        }
    }
</style>
